module.exports = __webpack_public_path__ + "static/media/addMemberGuide5_Jap.2546ba96.png";